import React, { useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import Content from "../../commons/components/content"
import DataHeader from "./dataHeader";
import DataSearch from "./dataSearch";
import DataTable from "./dataTable";

import { resetState } from '../../store/actions/certificationActions';

function Certifications(props) {
    const { selectedUser } = useSelector((state) => state.certification);
    const dispatch = useDispatch();

    useEffect(() => {
        return () => dispatch(resetState());
    }, []);

    return (
        <Content>
            <DataHeader />
            <DataSearch />
            {selectedUser.id ?
                <DataTable />
            : null}
        </Content>
    )
}

export default Certifications
